<template>
  <div>
    <!-- <mheader></mheader> -->
    <!-- 表单内容 -->
    <div
      v-show="tableData.length > 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/chaxun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            入库记录
          </span>
          <span class="ml-5">
            查询时间: 从
            <span style="color: red">
              {{ searchForm.DateLessThan | changeDate }}
            </span>
            到
            <span style="color: red">
              {{ searchForm.DateMoreThan | changeDate1 }}
            </span>
          </span>
          <span class="ml-5">
            总共有
            <span style="color: green; font-size: 20px">{{ Record }}</span>
            条数据
          </span>
          <span class="ml-5">
            总金额
            <span style="color: green; font-size: 20px">
              {{ total }}
            </span>
          </span>
          <span
            class="float-right span_close mr-1"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <p class="mb-2 mt-2">
          <span style="font-weight: 600; color: red"
            >温馨提示：2017年7月3日之前的入库记录可以不评价，之后的记录必须评价；入库记录只能查询最近3个月，当前默认显示最近一个月的记录</span
          >
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-5">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-7 P-0">
                        <div class="row ml-lg-1 text-center p-0 font">
                          销售日期:
                        </div>
                      </div>
                      <div class="col-lg-5 p-0">
                        <date2 @changeDate="changeDate1($event)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">到:</div>
                      <div class="col-lg-6 p-0">
                        <date @changeDate="changeDate2($event)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="row">
                  <div class="col-lg-6 font">供应商:</div>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control font"
                      v-model="Supplier"
                      style="height: 1.5rem"
                      @keydown.enter="searchEnterFun"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="row ml-lg-3">
                  <button
                    class="bg-primary button_zi mr-3 hei"
                    @click="Search()"
                  >
                    查询
                  </button>
                  <button
                    class="bg-primary button_zi hei"
                    @click="exportExcel()"
                  >
                    导出查询
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table
          v-if="searchData.length > 0"
          class="table table-striped table-hover"
          ref="print"
        >
          <thead>
            <tr style="white-space: nowrap">
              <th>入库单号</th>
              <th>药品名称</th>
              <th>产地名称</th>
              <th>规格</th>
              <th>单位</th>
              <th>包装</th>
              <th>批号</th>
              <th>数量</th>
              <th>单价</th>
              <th>库区</th>
              <th>金额</th>
              <th>日期</th>
              <th>供货单位</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in searchData" :key="index">
              <td>{{ item.orderNo }}</td>
              <td @dblclick="onInputdrugName(index)">{{ item.drugName }}</td>
              <td @dblclick="onInputcustomerName(index)">{{ item.addr }}</td>
              <td>{{ item.spec }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.package }}</td>
              <td>{{ item.batchNo }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.storeNo }}</td>
              <td>{{ item.money }}</td>
              <td>{{ item.date | formatUTC }}</td>
              <td>{{ item.supplierName }}</td>
              <td>
                <el-tag v-if="item.ispj" type="success">已评价</el-tag>
                <el-button
                  v-else
                  type="primary"
                  size="mini"
                  @click="toPj(item.orderNo)"
                  >评价</el-button
                >
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-hover" ref="print" v-else>
          <thead>
            <tr style="white-space: nowrap">
              <th>入库单号</th>
              <th>药品名称</th>
              <th>产地名称</th>
              <th>规格</th>
              <th>单位</th>
              <th>包装</th>
              <th>批号</th>
              <th>数量</th>
              <th>单价</th>
              <th>库区</th>
              <th>金额</th>
              <th>日期</th>
              <th>供货单位</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>{{ item.orderNo }}</td>
              <td @dblclick="onInputdrugName(index)">{{ item.drugName }}</td>
              <td @dblclick="onInputcustomerName(index)">{{ item.addr }}</td>
              <td>{{ item.spec }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.package }}</td>
              <td>{{ item.batchNo }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.storeNo }}</td>
              <td>{{ item.money }}</td>
              <td>{{ item.date | formatUTC }}</td>
              <td>{{ item.supplierName }}</td>
              <td>
                <el-tag v-if="item.ispj" type="success">已评价</el-tag>
                <el-button
                  v-else
                  type="primary"
                  size="mini"
                  @click="toPj(item.orderNo)"
                  >评价</el-button
                >
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 分页 -->
        <nav
          aria-label="Page navigation"
          style="text-align: center"
          v-if="this.Pcount !== 0"
          class="mb-1"
        >
          <ul class="pagination">
            <li
              class="page-item ml-5"
              :class="PageNo <= 1 ? 'disabled' : ''"
              @click="prePage()"
            >
              <a aria-label="Previous" class="page-link">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li
              :class="index == PageNo ? 'active' : ''"
              class="page-item"
              v-for="index of Pcount"
              :key="index"
              @click="curPage(index)"
            >
              <a class="page-link">{{ index }}</a>
            </li>
            <li
              class="page-item"
              :class="PageNo >= Pcount ? 'disabled' : ''"
              @click="nextPage()"
            >
              <a aria-label="Next" class="page-link">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
        <!-- <p class="text-center">
          总共有
          <span style="color:green;font-size:20px">{{Record}}</span>
          条数据

       </p>
       <p>
         查询时间: 从
         <span style="color:red">
             {{searchForm.DateLessThan | changeDate}}
         </span>
         到
         <span style="color:red">
           {{searchForm.DateMoreThan | changeDate1}}
         </span>
       </p> -->
      </div>
    </div>

    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/chaxun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            入库记录
          </span>
          <span class="ml-5">
            查询时间: 从
            <span style="color: red">
              {{ searchForm.DateLessThan | changeDate }}
            </span>
            到
            <span style="color: red">
              {{ searchForm.DateMoreThan | changeDate1 }}
            </span>
          </span>
          <span class="ml-5">
            总共有
            <span style="color: green; font-size: 20px">{{ Record }}</span>
            条数据
          </span>
          <span class="ml-5">
            总金额
            <span style="color: green; font-size: 20px">
              {{ total }}
            </span>
          </span>
          <span
            class="float-right span_close mr-1"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <p class="mb-2 mt-2">
          <span style="font-weight: 600; color: red"
            >温馨提示：2017年7月3日之前的入库记录可以不评价，之后的记录必须评价；入库记录只能查询最近3个月，当前默认显示最近一个月的记录</span
          >
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-5">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-7 P-0">
                        <div class="row ml-lg-1 text-center p-0 font">
                          销售日期:
                        </div>
                      </div>
                      <div class="col-lg-5 p-0">
                        <date2 @changeDate="changeDate1($event)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">到:</div>
                      <div class="col-lg-6 p-0">
                        <date @changeDate="changeDate2($event)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="row">
                  <div class="col-lg-6 font">供应商:</div>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control font"
                      v-model="Supplier"
                      style="height: 1.5rem"
                      @keydown.enter="searchEnterFun"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="row ml-lg-3">
                  <button
                    class="bg-primary button_zi mr-3 hei"
                    @click="Search()"
                  >
                    查询
                  </button>
                  <button
                    class="bg-primary button_zi hei"
                    @click="exportExcel()"
                  >
                    导出查询
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
    </div>

    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
import Loading from "../components/Loading.vue";
import date from "../components/Date.vue";
import date2 from "../components/Date2.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      date: new Date(),
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
        DateMoreThan: "",
        DateLessThan: "",
        DateLessThan1: "",
        DateMoreThan1: "", // 今天+1
      }, //搜索内容
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      total: "", //总金额
      Supplier: "", //供应商
    };
  },
  components: {
    // mheader,
    // mfooter,
    Loading,
    date,
    date2,
  },
  computed: {},
  filters: {
    //过滤器时间转换
    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    changeDate(date) {
      let change_date =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      return change_date + " 00:00:00";
    },
    changeDate1(date) {
      let time_change =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 9);
      let year = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(
          new Date(time_change).getTime() - 24 * 60 * 60 * 1000
        ).getMonth() + 1;

      let time_date = new Date(
        new Date(time_change).getTime() - 24 * 60 * 60 * 1000
      ).getDate();

      let time;
      if (month < 10) {
        if (time_date < 10)
          time = year + "-" + "0" + month + "-" + "0" + time_date;
        else {
          time = year + "-" + "0" + month + "-" + time_date;
        }
      } else {
        if (time_date < 10) {
          time = year + "-" + month + "-" + "0" + time_date;
        } else {
          time = year + "-" + month + "-" + time_date;
        }
      }

      let change_date = time;
      return change_date + " 23:59:59";
    },
  },

  methods: {
    //导出查询
    exportExcel() {
      const that = this;
      require.ensure([], async () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "入库单号",
          "药品名称",
          "产地名称",
          "规格",
          "单位",
          "包装",
          "批号",
          "数量",
          "单价",
          "库区",
          "日期",
          "供货单位",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "orderNo",
          "drugName",
          "addr",
          "spec",
          "unit",
          "package",
          "batchNo",
          "num",
          "price",
          "storeNo",
          "date",
          "supplierName",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        await that.getExcelData();
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "销售对账"); //最后一个是表
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //导出查询
    getExcelData: async function () {
      let that = this;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "ClerkInStore",
        obj: JSON.stringify({
          PageIndex: 1,
          PageSize: 50000,
          DrugName: that.searchForm.ypmc.trim(),
          BatchNum: that.searchForm.ph.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          Spec: that.searchForm.gg.trim(),
          DateLessThan: that.searchForm.DateMoreThan, // 销售日期不小于
          DateMoreThan: that.searchForm.DateLessThan, // 销售日期不大于
          Supplier: that.Supplier, //供应商
        }),
      });
      //  console.log(res)
      if (res.isok) {
        const obj = res.data;
        that.excelData = obj.rows;
        // console.log(that.excelData)
      }
    },

    // 评价
    toPj(rkdh) {
      this.$router.push({
        path: "/storePj",
        query: {
          rkdh,
        },
      });
    },

    time: function () {
      let year = this.date.getFullYear();
      let month = this.date.getMonth() + 1;
      let month1 = this.date.getMonth();
      let time_date = this.date.getDate();
      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }
      this.searchForm.DateMoreThan = time;
    },
    getLastMonthYestdy(Month) {
      var date = new Date();

      var daysInMonth = new Array(
        [0],
        [31],
        [28],
        [31],
        [30],
        [31],
        [30],
        [31],
        [31],
        [30],
        [31],
        [30],
        [31]
      );
      var strYear = date.getFullYear();
      var strDay = date.getDate();
      var strMonth = date.getMonth() + 1;
      if (strYear % 4 == 0 && strYear % 100 != 0) {
        daysInMonth[2] = 29;
      }
      if (strMonth - Month == 0) {
        strYear -= 1;
        strMonth = 12;
      } else {
        strMonth -= Month;
      }
      strDay = daysInMonth[strMonth] >= strDay ? strDay : daysInMonth[strMonth];
      if (strMonth < 10) {
        strMonth = "0" + strMonth;
      }
      if (strDay < 10) {
        strDay = "0" + strDay;
      }
      var datastr = "" + strYear + strMonth + strDay;
      this.searchForm.DateLessThan = datastr;
    },
    //动态绑定时间
    changeDate1: function (date) {
      this.searchForm.DateLessThan = date.replace(/\-/g, "");
      this.searchForm.DateLessThan1 = date;
    },
    changeDate2: function (date) {
      let year = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000).getMonth() + 1;

      let time_date = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getDate();
      // console.log(time_date)
      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }

      this.searchForm.DateMoreThan = time;
      // console.log(time)
      this.searchForm.DateMoreThan1 = date;
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },
    //验证
    // ypmc:function(){
    //     let reg1=/^[\u4e00-\u9fa5]{0,}$/;
    //      if(!reg1.test(this.searchForm.ypmc)){
    //            $("#ypmc").removeClass("d-none")
    //      }
    //      else{
    //           $("#ypmc").addClass("d-none")
    //      }
    // },
    // ph:function(){
    //      let reg2=/^[0-9]*$/;
    //      if(!reg2.test(this.searchForm.ph)){
    //            $("#ph").removeClass("d-none")
    //      }
    //      else{
    //           $("#ph").addClass("d-none")
    //      }
    // },
    // sccj:function(){
    //       let reg3=/^[\u4e00-\u9fa5]{0,}$/;
    //       if(!reg3.test(this.searchForm.cdmc)){
    //            $("#sccj").removeClass("d-none")
    //      }
    //      else{
    //            $("#sccj").addClass("d-none")
    //      }
    // },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc = this.searchData[index].drugName;
      } else {
        this.searchForm.ypmc = this.tableData[index].drugName;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].addr;
      } else {
        this.searchForm.cdmc = this.tableData[index].addr;
      }
    },

    getClerkInStore: async function (PageIndex) {
      // this.isLoading=true
      this.PageNo = PageIndex || this.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkInStore",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          DateLessThan: this.searchForm.DateMoreThan,
          DateMoreThan: this.searchForm.DateLessThan, // 销售日期不小于
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        this.tableData = obj.rows;
        this.Pcount = obj.pcount;
        this.Record = obj.record;
        this.total = obj.total;
        // this.isLoading = false
      }
    },
    // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDay1(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "" + tMonth + "" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },

    Search: async function (PageIndex) {
      //获取三个月前的时间戳   时间条件适合才可以查询
      const that = this;
      let threeMonth = that.getDay(-3 * 30);

      let threeMonthTime = new Date(threeMonth).getTime();

      let today = that.getDay(0);
      let todayTime = new Date(today).getTime();

      let select = that.searchForm.DateLessThan1;

      let select1 = that.searchForm.DateMoreThan1;
      let seTime = new Date(select).getTime();

      let seTime2 = new Date(select1).getTime();

      let ces = that.searchForm.DateLessThan;
      let a = ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
      // console.log(a)
      let ces1 = that.searchForm.DateMoreThan;
      let b =
        ces1.slice(0, 4) + "-" + ces1.slice(4, 6) + "-" + ces1.slice(6, 9);
      // console.log(b)
      let cesTime = new Date(a).getTime();
      // console.log(cesTime)
      let cesTime2 = new Date(b).getTime();
      // console.log(cesTime2)
      if (cesTime >= cesTime2) {
        alert("开始日期要小于结束日期");
      } else {
        if (
          threeMonthTime <= seTime &&
          seTime <= todayTime &&
          threeMonthTime <= seTime2 &&
          seTime2 <= todayTime
        ) {
          that.isLoading = true;
          if (!PageIndex) {
            PageIndex = 1;
          }
          that.PageNo = PageIndex || that.PageNo;
          const { data: res } = await this.$http.post("Dls/getFun", {
            action: "ClerkInStore",
            obj: JSON.stringify({
              PageIndex,
              PageSize: 20,
              DrugName: that.searchForm.ypmc.trim(),
              BatchNum: that.searchForm.ph.trim(),
              ProductFactory: that.searchForm.cdmc.trim(),
              Spec: that.searchForm.gg.trim(),
              DateLessThan: that.searchForm.DateMoreThan, // 销售日期不小于
              DateMoreThan: that.searchForm.DateLessThan, // 销售日期不大于
              Supplier: that.Supplier, //供应商
            }),
          });

          // console.log(res)
          if (res.isok) {
            const obj = res.data;
            if (that.Pcount === 0) {
              that.tableData = obj.rows;
            } else {
              that.searchData = obj.rows;
            }
            that.Pcount = obj.pcount;
            that.Record = obj.record;
            that.total = obj.total;
            that.isLoading = false;
            if (obj.pcount == 0) {
              alert("没有符合条件的信息");
              that.getClerkInStore();
            }
          }
        } else {
          alert("请选择三个月以内的时间进行查询,查询日期不大于当天");
        }
      }
    },
    // 当前页
    curPage: function (index) {
      if (this.searchData.length > 0) {
        this.Search(index);
      } else {
        this.getClerkInStore(index);
      }
    },
    //上一页
    prePage: function () {
      if (this.PageNo > 1) {
        this.PageNo--;
        if (this.searchData.length > 0) {
          this.Search(this.PageNo);
        } else {
          this.getClerkInStore(this.PageNo);
        }
      }
    },
    //下一页
    nextPage: function () {
      if (this.PageNo < this.Pcount) {
        this.PageNo++;
        if (this.searchData.length > 0) {
          this.Search(this.PageNo);
        } else {
          this.getClerkInStore(this.PageNo);
        }
      }
    },
    //搜索功能

    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    //this.time();
    // this.getLastMonthYestdy(1);
    this.searchForm.DateMoreThan = this.getDay1(1);
    this.searchForm.DateLessThan = this.getDay1(-29);
    this.getClerkInStore();
    this.searchForm.DateLessThan1 = this.getDay(-1);
    this.searchForm.DateMoreThan1 = this.getDay(0);
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.hei {
  height: 1.5rem;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.span_close:hover {
  color: #3190e8;
}
</style>

 



// WEBPACK FOOTER //
// src/pages/ClerkInStore.vue